import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X, Shield, Zap, Droplet, Key } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <Shield className="w-7 h-7 sm:w-8 sm:h-8 text-[#0066cc] flex-shrink-0" />
            <div className="flex flex-col leading-tight">
              <span className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900">Handwerkernotdienst NRW</span>
              <span className="text-xs text-gray-600 hidden sm:block">24/7 Schnelle Hilfe</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-[#0066cc] font-medium transition-colors" data-testid="nav-home">
              Start
            </Link>
            <Link to="/einsatzgebiete" className="text-gray-700 hover:text-[#0066cc] font-medium transition-colors" data-testid="nav-coverage">
              Einsatzgebiete
            </Link>
            <Link to="/kontakt" className="text-gray-700 hover:text-[#0066cc] font-medium transition-colors" data-testid="nav-contact">
              Kontakt
            </Link>
            <a
              href="tel:+4923139083687"
              className="flex items-center space-x-2 bg-[#0066cc] text-white px-4 py-2.5 rounded-full font-semibold hover:bg-[#0052a3] transition-colors text-sm"
              data-testid="header-call-button"
            >
              <Phone className="w-4 h-4" />
              <span className="hidden lg:inline">0231 39083687</span>
              <span className="lg:hidden">0231 3908...</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200" data-testid="mobile-menu">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-gray-700 hover:text-[#0066cc] font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-home"
              >
                Start
              </Link>
              <Link
                to="/einsatzgebiete"
                className="text-gray-700 hover:text-[#0066cc] font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-coverage"
              >
                Einsatzgebiete
              </Link>
              <Link
                to="/kontakt"
                className="text-gray-700 hover:text-[#0066cc] font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-contact"
              >
                Kontakt
              </Link>
              <a
                href="tel:+4923139083687"
                className="flex items-center justify-center space-x-2 bg-[#0066cc] text-white px-5 py-3 rounded-full font-semibold hover:bg-[#0052a3] transition-colors"
                data-testid="mobile-call-button"
              >
                <Phone className="w-5 h-5" />
                <span>0231 39083687</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;